import { MenuTree, MenuItemComponentProps } from '@shape-ds/components';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';
import React, { useMemo, useCallback, useEffect } from 'react';
import './NotificationsAssetSelect.scss';
import NotificationsAssetLine from './NotificationsAssetLine/NotificationsAssetLine';
import { clearDescendantsCache } from './checkboxHelper';
import { useFormContext } from 'react-hook-form';

const NotificationsAssetSelect: React.FC = () => {
  const { watch } = useFormContext();
  const { data } = useAssetsByWorkspaceQuery(watch('categories') as string[]);

  const treeData = useMemo(() => data?.items?.[0]?.children ?? [], [data?.items]);

  useEffect(() => {
    clearDescendantsCache();
  }, [data]);

  const customMenuItemComponent = useCallback(
    (props: MenuItemComponentProps) => <NotificationsAssetLine {...props} />,
    [],
  );

  return (
    <MenuTree
      data={treeData}
      customMenuItemComponent={customMenuItemComponent}
      className="notifications-manager-asset-select"
    />
  );
};

export default NotificationsAssetSelect;
